import React from 'react';
import { PageBanner } from '../components/PageBanner';
import { AboutSection } from '../components/AboutSection';
import { EmploymentSection } from '../components/EmploymentSection';
export function AboutPage() {
  return <main data-id="element-340">
      <PageBanner title="About Us" subtitle="Learn more about our mission, our team, and our commitment to your care." breadcrumbs={[{
      label: 'About Us',
      path: '/about'
    }]} data-id="element-341" />
      <AboutSection data-id="element-342" />
      <EmploymentSection data-id="element-343" />
    </main>;
}